import {
	VIEW_PAGE,
	EDIT_PAGE_V2,
	EDIT_BLOG_V2,
} from '@confluence/named-routes/entry-points/routes';

export const isEditOrLivePage = (url) => {
	const match =
		(VIEW_PAGE.match(url) && window.__SSR_IS_LIVE_PAGE__) ||
		EDIT_PAGE_V2.match(url) ||
		EDIT_BLOG_V2.match(url);

	return !!match;
};
